import React, { useEffect } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const CustomEvent = ({ event }) => {
  // console.log({ event });
  const navigate = useNavigate();

  // map from backend booking structure
  const services = (event.serviceList || []).map((s) => s?.title || "Untitled");
  const totalPrice = event.totalPrice ?? "—";
  const duration = event.totalTimeService ?? "—"; // mins
  const phone = event.customerPhone || event.customer_info?.mobile || "—";
  const customer = event.title || event.customer_info?.name || "—";
  const staff = event.staffName || event.selectedProfessional?.name || "—";
  const message = event.message || event.customer_info?.message;
  const bookingtype = event.bookingtype;
  const initial = customer?.charAt(0)?.toUpperCase() || "?";
  const isPast = moment(event.end).isBefore(moment());
  const isCancelled =
    event.bookingStatus === "cancelled" ||
    event.booking?.status === "cancelled";

  const paymentMethod = event.payments?.paymentMethod || "—";
  const paymentStatus = event.payments?.status || "pending";

  useEffect(() => {
    // Delegate clicks from tooltip
    const handler = (e) => {
      const target = e.target.closest("[data-tooltip-action]");
      if (target) {
        const action = target.getAttribute("data-tooltip-action");
        const id = target.getAttribute("data-id");

        if (action === "view") {
          navigate(`/booking/preview/${id}`);
        } else if (action === "edit") {
          navigate(`/booking/reschedule/${id}`);
        }
      }
    };

    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, [navigate]);

  function hexToRgba(hex, opacity) {
    let bigint = parseInt(hex.replace("#", ""), 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;
    return `rgba(${r},${g},${b},${opacity})`;
  }

  const backgroundColor = isCancelled
    ? "#f87171"
    : isPast
    ? "#d1d5db"
    : "#f3f4f6";

  const borderColor = isCancelled ? "#b91c1c" : isPast ? "#9ca3af" : "#9ca3af";

  const statusLabel = isCancelled
    ? "Cancelled"
    : isPast
    ? "Completed"
    : "Service";

  const tooltipHTML = `
    <style>
    .tooltip-btn {
      padding: 6px 12px;
      border-radius: 6px;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.2s ease;
    }
    .tooltip-btn.view {
      background: #f87171;
      color: white;
      border: none;
    }
    .tooltip-btn.view:hover {
      background: #dc2626; /* darker red */
    }
    .tooltip-btn.edit {
      background: none;
      color: #f87171;
      border: 1px solid #f87171;
    }
    .tooltip-btn.edit:hover {
      background: #f87171;
      color: white;
    }
    .tooltip-btn.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      background: #e5e7eb; /* gray-200 */
      color: #9ca3af;      /* gray-400 */
      border: 1px solid #d1d5db;
    }
    .tooltip-btn.disabled:hover {
      background: #e5e7eb;
      color: #9ca3af;
    }
  </style>

    <div style="
      width: 400px;
      border: 1px solid ${borderColor};
      border-radius: 10px;
      background-color: ${hexToRgba(backgroundColor, 1)};
      color: #1f2937;
      font-family: sans-serif;
      overflow: hidden;
      margin: 3px;
    ">
      <div style="
        background: ${borderColor};
        color: #fff;
        padding: 10px 14px;
        font-size: 13px;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        align-items: center;
      ">
        ${moment(event.start).format("h:mm A")} – ${moment(event.end).format(
    "h:mm A"
  )}
        <span>${statusLabel}</span>
      </div>

      <div style="padding: 14px;">
        <div style="display:flex; align-items:center; gap:12px;">
          <div style='width:40px; height:40px; border-radius:50%; background:#334155; display:flex; align-items:center; justify-content:center; font-weight:bold; font-size:16px; color:#facc15;'>
            ${initial}
          </div>
          <div style="flex-grow:1;">
            <div style="font-weight:600; text-transform: uppercase">
              ${customer}
              ${
                bookingtype === "walk-in"
                  ? `<span style="font-size:10px; background:#3b82f6; color:white; padding:2px 6px; border-radius:4px;">Walk-in</span>`
                  : `<span style="font-size:10px; background:#10b981; color:white; padding:2px 6px; border-radius:4px;">Online</span>`
              }
            </div>
            <div style="font-size:12px; color:#222;">${phone}</div>
          </div>
        </div>

        <div style="margin-top:12px; font-size:13px;">
          ${services.join(", ")}
          <div style="font-size:11px; color:#94a3b8;">${staff} • ${duration} min</div>
        </div>

        <hr style="margin:12px 0; border-color:#475569;" />

        <div style="font-size:12px; color:#222;">💲 Total: <strong>${totalPrice}</strong></div>
        <div style="font-size:12px; color:#222;">⏱ Duration: ${duration} mins</div>
        <div style="font-size:12px; color:${
          paymentStatus === "paid"
            ? "green"
            : paymentStatus === "failed"
            ? "red"
            : "orange"
        };">💳 ${paymentMethod} – ${paymentStatus}</div>

        ${
          message
            ? `<div style="margin-top:8px; font-size:12px; color:#facc15; background:#334155; padding:6px 10px; border-radius:6px; display:flex; align-items:center; gap:6px;">
                ⚠️ ${message}
              </div>`
            : ""
        }

              
 <!-- ✅ Buttons -->
        <div style="margin-top:14px; display:flex; gap:10px; justify-content:flex-end;">
    <button class="tooltip-btn view" data-tooltip-action="view" data-id="${
      event.id
    }">
      View 
    </button>
    <button 
      class="tooltip-btn edit ${isPast || isCancelled ? "disabled" : ""}" 
      data-tooltip-action="edit" 
      data-id="${event.id}"
      ${isPast || isCancelled ? "disabled" : ""}
    >
      Edit
    </button>
  </div>



    </div>
      </div>
    </div>
  `;

  // TEMP slot (hover only)
  if (event.temp) {
    return (
      <div className="flex items-center justify-start h-full w-full text-yellowlight text-[10px] ml-2">
        {event.title}
      </div>
    );
  }

  // Break event
  if (event.isBreak) {
    return (
      <div className="flex flex-col items-start justify-center h-full w-full text-dry text-[12px] ml-2">
        <p className="uppercase text-red-500">{event.title}</p>
        <div className="mt-1">
          {moment(event.start).format("h:mm A")} –{" "}
          {moment(event.end).format("h:mm A")}
        </div>
      </div>
    );
  }

  // Busy time
  if (event.isBusy) {
    return (
      <div className="flex flex-col items-start justify-center h-full w-full text-dry text-[12px] ml-2 font-semibold">
        <p className="uppercase text-red-500">{event.title}</p>
        <div className="mt-1">
          {moment(event.start).format("h:mm A")} –{" "}
          {moment(event.end).format("h:mm A")}
        </div>
      </div>
    );
  }

  // Main appointment UI
  return (
    <div
      className="p-2 text-sm h-full w-full"
      data-tooltip-id="event-tooltip"
      data-tooltip-html={tooltipHTML}
      style={{
        borderRadius: "6px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        fontSize: "13px",
        fontFamily: "sans-serif",
      }}
    >
      <div className="font-bold leading-tight flex items-center gap-2">
        <span className="capitalize">{customer}</span>
        <span
          className={`text-[10px] px-2 py-[1px] rounded ${
            bookingtype === "walk-in"
              ? "bg-blue-500 text-white"
              : "bg-green-500 text-white"
          }`}
        >
          {bookingtype === "walk-in" ? "Walk-in" : "Online"}
        </span>
      </div>
      <div className="text-xs leading-tight">{services.join(", ")}</div>
      <div className="text-[10px] text-gray-700">
        {moment(event.start).format("h:mm A")} –{" "}
        {moment(event.end).format("h:mm A")}
      </div>
      <div className="text-[10px] text-gray-700">💲 {totalPrice}</div>
      <div className="text-[10px] text-gray-700">⏱ {duration} mins</div>
      <div
        className={`text-[10px] ${
          paymentStatus === "paid"
            ? "text-green-600"
            : paymentStatus === "failed"
            ? "text-red-600"
            : "text-yellow-600"
        }`}
      >
        💳 {paymentMethod} – {paymentStatus}
      </div>
      {message && <div className="text-xs leading-tight">⚠️ {message}</div>}
    </div>
  );
};

export default CustomEvent;
